import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Badge, BADGE_TYPES } from 'src/components/Elements/Badge';
import { Grid } from 'src/components/HTKit/Grid';
import Button, { THEMES } from 'HTKit/Forms/Button';
import ServiceBanner from 'src/components/Service/ServiceBanner';
import List from './List';
import styles from './styles.scss';

const ProductInstallation = ({
  header = 'Installation & Setup Service',
  className = '',
  data = {},
  onClick = () => {},
}) => {
  const { value, steps = [], attachment: { original: originalImg } = { originalImg: '' } } = data;
  return (
    <>
      <div className={cn(styles.container, className)}>
        <Grid.Fluid>
          <Grid.Row>
            <Grid.Column sm={4} md={8} lgOffset={1} lg={4}>
              <Grid.Row>
                <Grid.Column sm={4} md={8} lg={12}>
                  <h4 className={styles.header}>{header}</h4>
                  {value && (
                    <Badge type={BADGE_TYPES.CONFIRMED} variant="solid" classes={styles.badge}>
                      Add Installation for only {value}
                    </Badge>
                  )}
                  <List
                    steps={steps}
                    className="marginTop-small2"
                    itemClassName="marginBottom-small"
                  />
                </Grid.Column>
                <Grid.Column sm={4} md={4} lg={12}>
                  <Button onClick={onClick} theme={THEMES.V2SECONDARY} className="marginTop-medium">
                    Add Installation Bundle to Cart
                  </Button>
                </Grid.Column>
              </Grid.Row>
            </Grid.Column>
            <Grid.Column lgOffset={1} lg={5}>
              <img
                src={originalImg}
                className={styles.image}
                alt="A HelloTech technician is installing a product."
              />
            </Grid.Column>
          </Grid.Row>
        </Grid.Fluid>
      </div>
      <ServiceBanner
        showBlobs={false}
        clockLabel=""
        checkmarkLabel="Peace of Mind Guarantee"
        theme="light"
        containerClasses={styles.banner}
      />
    </>
  );
};

ProductInstallation.propTypes = {
  header: PropTypes.string,
  className: PropTypes.string,
  data: PropTypes.shape({
    value: PropTypes.string,
    steps: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        description: PropTypes.string,
      }),
    ),
    attachment: PropTypes.shape({
      original: PropTypes.string,
    }),
  }),
  onClick: PropTypes.func,
};

export default memo(ProductInstallation);
